import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.timeout = null;

    if(this.inputTarget.value != "") {
      this.restoreFocus();
    }
  }

  debouncedSubmit() {
    // Submit form after a delay, after accumulating some keystrokes
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.form.requestSubmit();
    }, 500); // Delay in ms
  }

  restoreFocus() {
    // Focus the input field again
    this.inputTarget.focus();

    // Move the cursor to the end of the input value
    const val = this.inputTarget.value;
    this.inputTarget.value = "";
    this.inputTarget.value = val;
  }
}
